const server = {
  inDevelopment: process.env.NODE_ENV === 'development',
  env: process.env.NODE_ENV,
  host: process.env.REACT_APP_API_HOST,
  version: process.env.REACT_APP_API_VERSION,
}

export default server
